{
  "lastUpdatedAt": "2026-06-23T09:25:23.280Z",
  "lastFetchAttemptAt": "2026-06-23T09:25:23.280Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}